import { Users2, Mail, Shield } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';

const teamMembers = [
  { name: 'Sarah Johnson', email: 'sarah@veridex-one.com', role: 'CFO', status: 'active' },
  { name: 'Michael Chen', email: 'michael@veridex-one.com', role: 'CPO', status: 'active' },
  { name: 'Emma Williams', email: 'emma@veridex-one.com', role: 'CSO', status: 'active' },
  { name: 'David Brown', email: 'david@veridex-one.com', role: 'Analyst', status: 'active' },
  { name: 'Lisa Anderson', email: 'lisa@veridex-one.com', role: 'Analyst', status: 'invited' },
];

export default function Team() {
  return (
    <div data-testid="team-page" className="space-y-6">
      <h1 className="cp-page-title flex items-center gap-2"><Users2 className="w-6 h-6 text-accent" /> Team</h1>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <Card className="p-5 animate-fade-in stagger-1" data-testid="team-total">
          <p className="text-sm text-muted-foreground mb-1">Total Members</p>
          <p className="text-2xl font-heading font-bold">{teamMembers.length}</p>
        </Card>
        <Card className="p-5 animate-fade-in stagger-2" data-testid="team-active">
          <p className="text-sm text-muted-foreground mb-1">Active</p>
          <p className="text-2xl font-heading font-bold text-green-600">{teamMembers.filter(m => m.status === 'active').length}</p>
        </Card>
        <Card className="p-5 animate-fade-in stagger-3" data-testid="team-invited">
          <p className="text-sm text-muted-foreground mb-1">Invited</p>
          <p className="text-2xl font-heading font-bold text-amber-500">{teamMembers.filter(m => m.status === 'invited').length}</p>
        </Card>
      </div>

      <div className="cp-table-wrapper animate-fade-in">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Name</TableHead>
              <TableHead>Email</TableHead>
              <TableHead>Role</TableHead>
              <TableHead>Status</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {teamMembers.map((m) => (
              <TableRow key={m.email}>
                <TableCell className="font-medium flex items-center gap-2">
                  <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center text-xs font-semibold text-primary">
                    {m.name.split(' ').map(n => n[0]).join('')}
                  </div>
                  {m.name}
                </TableCell>
                <TableCell className="text-sm text-muted-foreground flex items-center gap-1"><Mail className="w-3 h-3" />{m.email}</TableCell>
                <TableCell><span className="flex items-center gap-1 text-sm"><Shield className="w-3 h-3 text-accent" />{m.role}</span></TableCell>
                <TableCell><span className={m.status === 'active' ? 'cp-badge-green' : 'cp-badge-amber'}>{m.status}</span></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
